/**
 * Presets de periodo do DRE. Mensais de proposito: DRE se le' por mes fechado,
 * nao por dia — "hoje" nao diz nada sobre resultado de empresa.
 *
 * Tudo em horario local: `toISOString()` converteria pra UTC e, depois das 21h
 * no Brasil, jogaria a data pro dia seguinte — o mes inteiro sairia deslocado.
 */
const iso = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;

export const PRESETS = [
  { key: "mes", label: "Este mês" },
  { key: "mes_passado", label: "Mês passado" },
  { key: "tri", label: "Últimos 3 meses" },
  { key: "ano", label: "Este ano" },
  { key: "custom", label: "Personalizado" },
];

export function intervalo(preset, hoje = new Date()) {
  const a = hoje.getFullYear();
  const m = hoje.getMonth();
  switch (preset) {
    case "mes":
      return { inicio: iso(new Date(a, m, 1)), fim: iso(hoje) };
    case "mes_passado":
      // Dia 0 do mes atual = ultimo dia do mes anterior. Resolve sozinho
      // fevereiro, ano bissexto e virada de ano.
      return { inicio: iso(new Date(a, m - 1, 1)), fim: iso(new Date(a, m, 0)) };
    case "tri":
      return { inicio: iso(new Date(a, m - 2, 1)), fim: iso(hoje) };
    case "ano":
      return { inicio: iso(new Date(a, 0, 1)), fim: iso(hoje) };
    default:
      return { inicio: iso(new Date(a, m, 1)), fim: iso(hoje) };
  }
}

export const brl = (v) =>
  (v < 0 ? "-" : "") +
  "R$ " +
  Math.abs(Number(v) || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/** "67,6%" — porcentagem com vírgula, como o dinheiro (antes saía "67.6%"). */
export const pct = (v) =>
  `${(Number(v) || 0).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;

export const rotuloPeriodo = (inicio, fim) => {
  const f = (s) => (s || "").split("-").reverse().join("/");
  return `${f(inicio)} a ${f(fim)}`;
};
